import type { ComponentPropsWithoutRef, ElementType } from "react";

import { styled } from "simplydo/react/styled";

import { type UiColorPalette, useUiColor } from "../../utils/UIContext";

type ColorProps = { $color: UiColorPalette };

const StyledOutline = styled.button<ColorProps>`
  background: transparent none;
  color: ${({ $color }) => $color.ink};
  box-shadow: 0 0 0 1px ${({ $color }) => $color.strong} inset;
  font-weight: normal !important;

  &:hover {
    background-color: ${({ $color }) => $color.softer};
    color: ${({ $color }) => $color.ink};
    box-shadow: 0 0 0 1px ${({ $color }) => $color.strong} inset;
  }

  &:active {
    color: ${({ $color }) => $color.ink};
    background-color: ${({ $color }) => $color.soft};
    box-shadow:
      0 0 0 1px ${({ $color }) => $color.strong} inset,
      0 1px 4px 0 rgba(34, 36, 38, 0.15) inset;
  }
`;

type Props = ComponentPropsWithoutRef<"button"> & {
  as?: ElementType;
  className?: string;
};

export function OutlineButton({ as, className, ...props }: Props) {
  const uiColor = useUiColor();
  return (
    <StyledOutline as={as} className={className} $color={uiColor} {...props} />
  );
}
